import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from './experiments';
import {
  reverb_search_ListingsSearchRequest as ListingsSearchRequest,
  reverb_search_ListingItemRegionRelation as ItemRegionRelation,
} from './rql';
import { get as getCookie } from 'js-cookie';

function isNonUSUser(user: Partial<IUser>) {
  return !!user?.countryCode && user.countryCode !== 'US';
}

export function localizeCSPForUser(user: Partial<IUser>) {
  return !!user?.countryCode && !['US', 'AU'].includes(user.countryCode);
}

export function trackLocalizeCSPCardExperiment(user: Partial<IUser>) {
  if (isNonUSUser(user)) {
    return [experiments.LOCALIZE_CSP_CARD];
  }

  return [];
}

export function trackLocalizeCspsSuperRegionExperiment(user: Partial<IUser>) {
  if (localizeCSPForUser(user)) {
    return [experiments.LOCALIZE_CSPS_SUPER_REGION];
  }

  return [];
}

export function isUserInCSPShowFeaturedInCollection(user: Partial<IUser>) {
  return isExperimentEnabled(user, experiments.CSP_SHOW_FEATURED_IN_COLLECTION);
}

export function isUserInLocalizeCSPCardExperiment(user: Partial<IUser>) {
  const isEnabled = isExperimentEnabled(user, experiments.LOCALIZE_CSP_CARD);

  return isNonUSUser(user) && isEnabled;
}

export function isUserInLocalizeCspsSuperRegionExperiment(user: Partial<IUser>) {
  const isEnabled = isExperimentEnabled(user, experiments.LOCALIZE_CSPS_SUPER_REGION);

  return localizeCSPForUser(user) && isEnabled;
}

export function localizeCspsSuperRegionExperimentFilters(itemRegionQueryParam, user: Partial<IUser>): ListingsSearchRequest {
  if (itemRegionQueryParam) {
    return {
      itemRegion: itemRegionQueryParam,
    };
  }

  if (isUserInLocalizeCspsSuperRegionExperiment(user)) {
    return {
      itemRegion: user.countryCode,
      itemRegionRelation: ItemRegionRelation.INCLUDE_TRADE_REGIONS,
    };
  }

  if (localizeCSPForUser(user)) {
    return {
      itemRegion: user.countryCode,
    };
  }

  return {
    itemRegion: getCookie('itemRegionOverride'),
  };
}
